module.exports = __webpack_public_path__ + "img/academy-hero-img.19ba4aea.svg";